<script>

export let sin = A;
export let list = 0;

export const sins1 = {
    "A": "Apathy",
    "B": "Bitterness",
    "C": "Coveting stuff",
    "D": "Drunkenness",
    "E": "Making stuff up",
    "F": "Unrepentance",
    "G": "Greediness",
    "H": "Hypocrisy",
    "I": "Ignorance",
    "J": "Jealousy",
    "K": "Kleptomania",
    "L": "Lustfulness",
    "M": "Murder",
    "N": "Neglect",
    "O": "Objectification",
    "P": "Pridefullness",
    "Q": "Quarrelsomeness",
    "R": "Stealing stuff",
    "S": "Selfishness",
    "T": "Thoughtlessness",
    "U": "Unforgiveness",
    "V": "Vanity",
    "W": "Workoholism",
    "X": "Xenophobia",
    "Y": "Yelling obscenities",
    "Z": "Zenlessness",
    "0": "Abuse",

    
}
export const sins2 = {
    "A": "Abuse",
    "B": "General badness",
    "C": "Cheating",
    "D": "Deceit",
    "E": "Egocentricity",
    "F": "Foulness",
    "G": "Muckraking",
    "H": "Hatred",
    "I": "Impurity",
    "J": "Jackassery",
    "K": "Kicking against the pricks",
    "L": "Leering",
    "M": "Misery",
    "N": "Nastiness",
    "O": "Obsessing",
    "P": "Pettiness",
    "Q": "Quitting",
    "R": "Resentment",
    "S": "Slothfullness",
    "T": "Bullying",
    "U": "Uncompassion",
    "V": "Vengeance",
    "W": "Wretchedness",
    "X": "Extremism",
    "Y": "Lying too much",
    "Z": "Zealotry"
}

</script>

{#if list == 0}
{sins1[sin]}
{:else}
{sins2[sin]}
{/if}
